import { useReactiveVar } from "@apollo/client";
import { FC } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { editNavigationVar } from "../../../App";
import "./Toolbar.css";
import { Icon } from "../../../Components/Icon/Icon";
import { ToolbarActions } from "./ToolbarActions/ToolbarActions";
import { ValidIcons } from "../../../Components/Icon/Icon-list";

type Props = {
  logoName: ValidIcons;
};

export const Toolbar: FC<Props> = ({ logoName }) => {
  const location = useLocation();
  const history = useHistory();
  const editNavigation = useReactiveVar(editNavigationVar);

  const split = location.pathname.split("/");
  const pathState = split[split.length - 1];

  const isHomePath = pathState === "main" || pathState === "overview";

  const isEditProduct = location.pathname.includes("/edit/product/");
  const isEditGroup = location.pathname.includes("/edit/group/");

  const selectedName =
    (isEditProduct || isEditGroup) &&
    editNavigation?.selectedProductNumber === pathState
      ? editNavigation.selectedName
      : undefined;

  const isSettingsPage = location.pathname.includes("settings") ? true : false;

  return (
    <div className="Toolbar">
      <div className="Toolbar__content">
        <div className="Toolbar__navpath" onClick={() => history.push("/main")}>
          <div className="Toolbar__home">
            {!isHomePath ? (
              <Icon name="homeActive" width={98} height={100} />
            ) : (
              <Icon name="home" width={98} height={100} />
            )}
          </div>
          {selectedName && (
            <div className="Toolbar__subpath">{selectedName}</div>
          )}
          {isSettingsPage && (
            <div className="Toolbar__subpath">Indstillinger</div>
          )}
        </div>
        <div className="Toolbar__logo">
          <Icon name={logoName} width={40} />
        </div>
        <div className="Toolbar__actions">
          <ToolbarActions />
        </div>
      </div>
    </div>
  );
};
